<template>
  <ButtonPrimary @click="openIntercom">
    <FontAwesomeIcon
      class="mr-2"
      icon="bolt"
    />
    {{ $t('upsell.contact_us') }}
  </ButtonPrimary>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ButtonUpsell',

  props: {
    feature: { type: String, required: true },
  },

  computed: {
    ...mapGetters(['current_profile']),
  },

  methods: {
    openIntercom() {
      const message = this.$t(`upsell.${this.feature}.intercom`, { name: this.current_profile.attributes.name });
      window.Intercom('showNewMessage', message);
    },
  },
};
</script>
